import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import getConfig from '../../../config';
import ThreadItem from '../../../threaditem';
import ChatView from '@bit/super-mario.yoshi.chatview';
import './recommendations.css';

const RECOMMENDATION_REQ_COUNT = 25;

class Recommendations extends Component {

  constructor(props) {
    super(props);
    this.state = {
      recommendations: [],
      recommended_threads: [],
      token: null
    }
  }

  async componentDidMount() {
    const config = getConfig();
    const { user } = this.props;
    const userId = user.user_id || 'anonymous';
    // Get the list of threads for the ids returned by the recommender.
    const header = {'mario-user_id' : userId};
    const service_url = config.luigi.domain + config.luigi.services.thread_recommended;
    const threads_response = await axios.get(service_url, {headers: header});
    const threads = threads_response.data || {};
    this.setState({'recommended_threads': threads});

    const get_token_url = config.daisy.domain + config.daisy.services.get_twilio_token + '/anonymous';
    
    const tokenData = await axios.get(get_token_url)
    const token = (tokenData && tokenData.data) || null;
    this.setState({
      ...this.state,
      token
    })
  }

  render() {
    if (!this.state.token) return null;

    const threadList = this.state.recommended_threads && this.state.recommended_threads
    .filter(thread => !thread.disabled)
    .map(thread => (
      <div key={thread.id} className="thread-chat">
        <ThreadItem key={thread.id} thread={thread} />
        <ChatView channelId={thread.channelId} />
      </div>
    ));
    return (
      <div className='recommended-threads'>
        <div className='thread-list'>
          <ul>
            {threadList}
          </ul>
        </div>
      </div>
    );
  }

}


Recommendations.propTypes = {
	user: PropTypes.object
}

const mapStateToProps = (state) => {
	return {
		user: state.user
	};
};

export default connect(mapStateToProps, null)(Recommendations);